/**
 * Omnyqra product identity for customer-visible text (Omnyqra/sim#41), see FORK.md.
 *
 * Plain constants without env reads, so blocks, tools, triggers, the executor
 * and server code can import them alike. Surfaces that already read
 * `getBrandConfig().name` keep doing so; both resolve to the same default.
 */
import { defaultBrandConfig } from '@/lib/branding/defaults'

/** Product name shown to customers and third parties. */
export const BRAND_NAME = defaultBrandConfig.name

/** Public homepage, used as contact URL in User-Agent and Referer headers. */
export const BRAND_HOMEPAGE = 'https://omnyqra.ai'

/** Contact for vulnerability reports (`security.txt`). */
export const SECURITY_EMAIL = 'security@omnyqra.ai'

/** Default User-Agent for outbound requests made on a customer's behalf. */
export const BRAND_USER_AGENT = `${BRAND_NAME}/1.0 (+${BRAND_HOMEPAGE})`
